import React from 'react';
export function Shipping() {
  const features = [{
    icon: '📦',
    title: 'Embalaje Reforzado Triple Capa',
    desc: 'Espuma de alta densidad + papel burbuja + caja rígida exterior.'
  }, {
    icon: '🔍',
    title: 'Tracking en Tiempo Real',
    desc: 'Te enviamos el número de seguimiento para que puedas rastrear tu pedido.'
  }, {
    icon: '⚡',
    title: 'Despacho en 48-72hs hábiles',
    desc: 'Confirmado el pago, tu pedido sale en menos de 3 días hábiles.'
  }];
  return <section id="envios" className="py-[100px] px-[5%] relative z-10 bg-[#0a0a0a] border-t border-dark-border" data-id="element-108">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-20 items-center" data-id="element-109">
        {/* TEXT SIDE */}
        <div data-id="element-110">
          <div className="text-[0.7rem] tracking-[4px] uppercase text-neon-pink mb-3" data-id="element-111">
            — Envíos
          </div>
          <h2 className="font-bebas text-[clamp(2.2rem,5vw,4rem)] leading-none mb-4" data-id="element-112">
            LLEGAMOS A<br data-id="element-113" />
            TODO EL PAÍS
          </h2>
          <p className="text-text-muted text-base max-w-[520px] leading-[1.7] mb-0" data-id="element-114">
            Desde Venado Tuerto hasta la Patagonia. Embalaje reforzado con
            triple protección para que tu cuadro llegue perfecto, siempre.
          </p>
          <ul className="list-none mt-9 flex flex-col gap-5" data-id="element-115">
            {features.map((feat, i) => <li key={i} className="flex items-start gap-4 text-[0.9rem] text-[#ccc] leading-[1.5]" data-id="element-116">
                <div className="w-9 h-9 rounded-md bg-neon-pink/10 border border-neon-pink/20 flex items-center justify-center text-base shrink-0" data-id="element-117">
                  {feat.icon}
                </div>
                <div data-id="element-118">
                  <strong className="text-white font-semibold" data-id="element-119">
                    {feat.title}
                  </strong>
                  <br data-id="element-120" />
                  <span className="text-text-muted" data-id="element-121">{feat.desc}</span>
                </div>
              </li>)}
          </ul>
        </div>

        {/* MAP SIDE */}
        <div className="relative flex items-center justify-center" data-id="element-122">
          <svg className="w-full max-w-[340px] drop-shadow-[0_0_40px_rgba(191,0,255,0.3)]" viewBox="0 0 200 400" xmlns="http://www.w3.org/2000/svg" data-id="element-123">
            <defs data-id="element-124">
              <linearGradient id="mapGrad" x1="0%" y1="0%" x2="100%" y2="100%" data-id="element-125">
                <stop offset="0%" stopColor="#ff2d78" stopOpacity="0.8" data-id="element-126" />
                <stop offset="100%" stopColor="#bf00ff" stopOpacity="0.8" data-id="element-127" />
              </linearGradient>
            </defs>
            <path d="
              M 75,10 L 130,10 L 150,30 L 155,60 L 145,90 L 155,110 L 150,140 L 140,160 L 145,185 L 135,210 L 125,235 L 115,260 L 100,285 L 85,310 L 75,330 L 65,350 L 58,365 L 55,370 L 50,360 L 48,340 L 55,320 L 60,300 L 55,280 L 50,260 L 55,235 L 50,210 L 45,185 L 50,160 L 45,140 L 50,110 L 45,90 L 50,65 L 55,40 L 65,20 Z
            " fill="url(#mapGrad)" stroke="rgba(255,45,120,0.3)" strokeWidth="1" opacity="0.7" data-id="element-128" />

            {/* Venado Tuerto Point */}
            <circle cx="88" cy="175" r="5" fill="#ff2d78" data-id="element-129" />
            <circle cx="88" cy="175" r="10" fill="none" stroke="#ff2d78" strokeWidth="1" opacity="0.5" className="animate-pulse-ring origin-center" style={{
            transformBox: 'fill-box',
            transformOrigin: 'center'
          }} data-id="element-130" />

            <text x="96" y="173" fill="#ff2d78" fontSize="8" fontFamily="Inter, sans-serif" fontWeight="600" data-id="element-131">
              Venado Tuerto
            </text>

            {/* Other dots */}
            <circle cx="95" cy="290" r="3" fill="rgba(0,240,255,0.6)" data-id="element-132" />
            <circle cx="100" cy="100" r="3" fill="rgba(0,240,255,0.6)" data-id="element-133" />
            <circle cx="75" cy="200" r="3" fill="rgba(0,240,255,0.6)" data-id="element-134" />
            <circle cx="105" cy="140" r="3" fill="rgba(0,240,255,0.6)" data-id="element-135" />
            <circle cx="80" cy="250" r="3" fill="rgba(0,240,255,0.6)" data-id="element-136" />
            <circle cx="115" cy="170" r="3" fill="rgba(0,240,255,0.6)" data-id="element-137" />
          </svg>
        </div>
      </div>
    </section>;
}